import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../hooks';
import type { NoteState, VisitStatus } from '../../models/providerHome';

type VisitPatch = { status?: VisitStatus; noteState?: NoteState };

/** Confirm a visit or flip its chart-note state, then refetch the day. */
export const useUpdateVisit = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });

  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: VisitPatch }) =>
      api({
        route: `/private/provider-home/visit/${id}`,
        method: 'PATCH',
        payload: patch,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['provider-home-appointments'],
      }),
  });
};

/** Dismiss a task, then refetch the task list. */
export const useDismissTask = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });

  return useMutation({
    mutationFn: (id: string) =>
      api({
        route: `/private/provider-home/task/${id}/dismiss`,
        method: 'PATCH',
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['provider-home-tasks'] }),
  });
};
